import { EntityIconProfile } from '@components/core-ui/EntityIcon/variations/EntityIconProfile';
import { JobDtoUser } from 'app/API';
import { AvatarBlock } from './styles/AvatarBlock';

export const AvatarContent = ({ user }: { user: JobDtoUser }) => {
  if (!user) {
    return null;
  }
  return (
    <AvatarBlock>
      <EntityIconProfile name={`${user.name} ${user.lastname}`} src={user.avatar ?? undefined} />
    </AvatarBlock>
  );
};
